import { get } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import RSVP from 'rsvp';

export default Route.extend({
  fundsService: service(),
  storeCache: service(),
  store: service(),

  beforeModel() {
    return this.fundsService.confirmValidFundToken();
  },

  model() {
    let user = this.modelFor('admin.users.show');
    let userId = get(user, 'id');
    let storeCache = this.storeCache;
    let promise = RSVP.hash({
      funds: storeCache.findAll('admin/fund'),
      userFunds: this.store.query('admin/user-fund', {
        filter: { user_id: userId },
      }),
    });
    return promise.then((data) => {
      return {
        user: user,
        funds: data.funds,
        userFunds: data.userFunds,
      };
    });
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
